/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Modal } from 'components'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import RemoveIcon from '@mui/icons-material/Remove'
import { BGC_FIELDS } from 'utils/constants/bgcFields'
import { APPLICATION_RESULT_MESSAGES, APPLICATION_STATUS, APPLICATION_STATUS_MESSAGES } from 'utils/constants/kypStatuses'
import { buildScore, gotoUrl, maskString } from 'utils/functions'
import classNames from 'classnames'
import ApplicationLog from 'components/ApplicationLog'
import NotFoundMessage from 'components/NotFoundMessage'
import Colors from 'utils/Colors'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'
import StatusText from 'components/StatusText'
import styles from './styles'
import BuildBgcRowFields from '../BackgroundCheckTable/BackgroundCheckDataBuilder'
import OpenApplicationButton from './OpenApplicationButton'

const ResumeTable = (props) => {
  const { data: tableData } = props
  const excludedFields = [BGC_FIELDS.financial_situation]

  const classes = styles()

  const [logModal, setLogModal] = useState(false)
  const [currentApplication, setCurrentApplication] = useState(null)

  const handleCloseLogModal = () => {
    setLogModal(false)
    setCurrentApplication(null)
  }

  const buildFormStatus = (application) => {
    const { form } = application
    const isExpired = (date) => {
      const date_to_test = moment(date)
      const now = moment()
      return now.diff(date_to_test, 'hours') > 0
    }

    const formStatusIcon = (expireDate, filled) => {
      const expired = isExpired(expireDate)

      if (expired && !filled) {
        return <CancelIcon style={{ color: Colors.red }} />
      }
      if (!expired && !filled) {
        return <AccessTimeIcon style={{ color: Colors.gray }} />
      }
      return <CheckCircleIcon style={{ color: Colors.green }} />
    }

    try {
      return (
        <td key="formStatus">{formStatusIcon(form.expires_at, form.filled)}</td>
      )
    } catch (err) {
      return <td>N/A</td>
    }
  }

  const createScore = (score) => {
    return score != null ? (
      <div className={classes.score} style={buildScore(score)}>
        {score}
      </div>
    ) : (
      <div>
        <AccessTimeIcon style={{ color: Colors.gray }} />
      </div>
    )
  }

  const renderResult = (result) => {
    const status = {
      APPROVED: <StatusText color={Colors.green}>{APPLICATION_RESULT_MESSAGES.APPROVED}</StatusText>,
      REPROVED: <StatusText color={Colors.red}>{APPLICATION_RESULT_MESSAGES.REPROVED}</StatusText>,
    }

    return status[result]
  }

  const showStatus = (application) => {
    let content = null
    switch (application.status) {
      case APPLICATION_STATUS.DD_IN_PROGRESS:
        content = APPLICATION_STATUS_MESSAGES.DD_IN_PROGRESS
        break
      case APPLICATION_STATUS.PROCESSING_MATCH:
        content = APPLICATION_STATUS_MESSAGES.PROCESSING_MATCH
        break
      case APPLICATION_STATUS.PROCESSED:
        content = renderResult(application.result)
        break
      case APPLICATION_STATUS.EXPIRED:
        content = APPLICATION_STATUS_MESSAGES.EXPIRED
        break
      case APPLICATION_STATUS.WAITING_REVIEW:
        content = APPLICATION_STATUS_MESSAGES.WAITING_REVIEW
        break
      case APPLICATION_STATUS.PROCESSING_BGC:
        content = APPLICATION_STATUS_MESSAGES.PROCESSING_BGC
        break
      default:
        break
    }
    return (
      <span style={{ fontSize: '1.25rem' }}>
        {content || <RemoveIcon style={{ color: Colors.gray }} />}
      </span>
    )
  }
  const handleOpenDetails = (application_uuid) => {
    gotoUrl(
      `${ROUTE_CONSTANTS.APPLICATION_DETAILS}?application_uuid=${application_uuid}`,
    )
  }

  const buildAntifraudeCheck = (application) => {
    const antifraude = application?.prospect?.latest_antifraude
    if (!antifraude) {
      return <RemoveIcon style={{ color: Colors.gray }} />
    }
    if (!antifraude.finished) {
      return <AccessTimeIcon style={{ color: Colors.gray }} />
    }

    return antifraude.approved ? <CheckCircleIcon style={{ color: Colors.green }} /> :
      <CancelIcon style={{ color: Colors.red }} />
  }

  useEffect(() => {
    if (currentApplication) setLogModal(true)
  }, [currentApplication])

  return (
    <React.Fragment>
      <table className={classes.dataTable}>
        <thead>
        <tr>
          <th colSpan={21} className={classes.manualAnalisysHeader}>
          </th>
        </tr>
        <tr>
          <th colSpan={3} />
          <th colSpan={2} className={classes.scoreRelatedHeader}>
            Etapas Iniciais
          </th>
          <th colSpan={10} className={classes.bgcRelatedHeader}
              style={{ borderRight: '1px solid #FFFFFF' }}
          >
            {' '}
            Background Check
          </th>
          <th colSpan={3} className={classes.bgcRelatedHeader}>
            {' '}
            Score
          </th>
          <th colSpan={3} />
        </tr>
        <tr>
          <th>Início do Processo</th>
          <th style={{ minWidth: '150px' }}>Nome</th>
          <th style={{ minWidth: '95px' }}>CPF</th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            Antifraude
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
            style={{ borderRight: '1px solid #FFFFFF' }}
          >
            Due Diligence
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            Compliance List
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            Região de risco
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            Mídia Negativa
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            PEP
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            Processos Judiciais
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            Listas Restritivas
          </th>
          <th className={classNames(classes.iconContent, classes.bgcHeaders)}>
            Pessoa vinculada
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            Participação societária e ESG
          </th>
          <th className={classNames(classes.iconContent, classes.rfcHeaders)}>
            Score de crédito
          </th>
          <th className={classNames(classes.iconContent, classes.rfcHeaders)}
              style={{ borderRight: '1px solid #FFFFFF' }}
          >
            Pendências financeiras
          </th>
          <th className={classes.bgcHeaders}>Score do BGC</th>
          <th className={classes.bgcHeaders}>Score do DD</th>
          <th className={classes.bgcHeaders}>Score Final</th>

          <th style={{ minWidth: 70 }}>Status</th>
          <th>Conteúdo</th>
        </tr>
        </thead>
        <tbody>
        {tableData.length > 0 ? (
          addKeyToObjectsArray(tableData).map((application) => {
            return (
              <tr  style={{ height: 55 }} key={application.key} className={classes.cursorPointer}>
                <td>
                  {moment(application.created).format('DD/MM/YYYY')}
                  <br />
                  {moment(application.created).format('HH:mm')}
                </td>

                <td>
                  {application?.prospect?.person?.name ? (
                    application?.prospect?.person?.name
                  ) : (
                    <AccessTimeIcon style={{ color: Colors.gray }} />
                  )}
                </td>

                <td>
                  {application?.prospect?.person?.cpf ? (
                    maskString(application?.prospect?.person?.cpf, 'cpf')
                  ) : (
                    <AccessTimeIcon style={{ color: Colors.gray }} />
                  )}
                </td>
                <td>
                  {buildAntifraudeCheck(application)}
                </td>

                {buildFormStatus(application)}

                {BuildBgcRowFields(application.background_check, excludedFields)}

                <td>
                  {createScore(application?.due_diligence_score_board?.final_score)}
                </td>

                <td>
                  {createScore(application?.final_score)}
                </td>

                <td className={classes.applicationStatus}>{showStatus(application)}</td>

                <td>
                  <div className={classes.detailsContent}>
                    <OpenApplicationButton
                      applicationData={application}
                      onClick={() => handleOpenDetails(application.uuid)}
                    />
                  </div>
                </td>
              </tr>
            )
          })
        ) : (
          <tr>
            <td colSpan="20" className={classes.emptyTable}>
              <NotFoundMessage message="Nenhum resultado encontrado" />
            </td>
          </tr>
        )}
        </tbody>
      </table>

      <Modal
        open={logModal}
        onClose={() => handleCloseLogModal()}
        title="Registro de atividades da aplicação"
      >
        <ApplicationLog applicationData={currentApplication} />
      </Modal>
    </React.Fragment>
  )
}

export default ResumeTable
